import { IMediaItem, IMediaItemMeta, MediaStatus } from 'types/media'
import { IProjectData } from 'types/projectData'

import { PROJECT_MEDIA_TYPES } from 'consts'
import { isBlobUrl } from '.'
import { IAudioItem } from 'types/audio'

//filter out media , audios because they still uploading in server
//and after uploading we will update the project data with the new values

export const filterMediaItemsWithBlobUrl = (
  mediaItems: IMediaItem[]
): IMediaItem[] => {
  return mediaItems.filter(
    item =>
      item.type === PROJECT_MEDIA_TYPES.text ||
      (item.meta.path && !isBlobUrl(item.meta.path)) ||
      item.meta.status === MediaStatus.PENDING
  )
}

export const filterMultilineAudiosWithEmptyAssetId = (
  multilineAudios: IAudioItem[]
): IAudioItem[] => {
  return multilineAudios.filter(audio => audio.assetId !== '')
}

const sanitizeMediaItemMeta = (
  meta: IMediaItemMeta & Record<string, unknown>
): IMediaItemMeta => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { effects, ...rest } = meta
  return rest as IMediaItemMeta
}

// Do all project data sanitization here
export const sanitizeProjectData = (data: IProjectData): IProjectData => {
  const filteredItems = filterMediaItemsWithBlobUrl(data.mediaItems)
  return {
    ...data,
    mediaItems: filteredItems.map(item => ({
      ...item,
      meta: sanitizeMediaItemMeta(
        item.meta as IMediaItemMeta & Record<string, unknown>
      )
    })),
    multilineAudios: filterMultilineAudiosWithEmptyAssetId(data.multilineAudios)
  }
}
